import React from "react";
import {
  BannerWrapper,
  Container,
  ContentBottom,
  HintScroll,
  PialaByuImg,
  ScrollDownIcon,
  TitleImg,
} from "./Banner.styled";
import { Container as ContainerGrid, Row, Col } from "react-grid-system";

import { func } from "../../../../utils";
import _function from "../../../../utils/function";
import useWindowSize from "../../../../hooks/useWindowSize";
// import LiveBanner from "../../../atoms/LiveBanner";
import LiveBannerNew from "../../../atoms/LiveBannerNew";
import {
  Box,
  ContainerHeadline,
  Headline,
} from "../BannerCity/BannerCity.styled";
import { Text } from "../../../atoms";
import Card from "../../../atoms/NewCard";
import { JadwalKlasemenContainer } from "../../../../pages/v2/HomeDetails/HomeDetails.styled";
import { usePageContextState } from "../../../../context/PageContext";
import { useNavigate } from "react-router-dom";
import { useURLParams } from "../../../../hooks/useURLParams";
import moment from "moment";

const BannerSoc = ({ data, slug, children }) => {
  const { isLive } = usePageContextState();
  const { buildURLWithParams } = useURLParams();
  const event_start_date = data?.event_start_date;
  const event_end_date = data?.event_end_date;
  const currentDate = moment().format("YYYY-MM-DD");

  const isOnGoingEvent =
    event_start_date &&
    event_end_date &&
    currentDate >= moment(event_start_date).format("YYYY-MM-DD") &&
    currentDate <= moment(event_end_date).format("YYYY-MM-DD");

  const isSameMonthEvent =
    moment(event_start_date).format("MMMM") ===
    moment(event_end_date).format("MMMM");
  const isSameDayEvent =
    moment(event_start_date).format("D") === moment(event_end_date).format("D");
  const isSameYearEvent =
    moment(event_start_date).format("YYYY") ===
    moment(event_end_date).format("YYYY");
  const labelStartEvent = moment(event_start_date).format(
    isSameMonthEvent ? "D" : isSameYearEvent ? "DD MMMM" : "DD MMMM YYYY"
  );
  const eventDate = `${isSameDayEvent ? "" : labelStartEvent + " -"} ${moment(
    event_end_date
  )?.format("D MMMM YYYY")}`;

  const loc = data?.location || "-";
  const city = data?.location?.includes("UNJ")
    ? "JAKARTA"
    : String(data?.city)?.toUpperCase();
  // const city = data?.city ? String(data?.city)?.toUpperCase() : "-";

  const navigate = useNavigate();
  const { size } = useWindowSize();

  const isSmallScreen = (size?.height || 0) <= 667;
  const isExtraSmallScreen =
    (size?.width || 0) <= 375 && (size?.height || 0) <= 600;
  const isMobileView = (size?.width || 0) <= 830;
  const handleScroll = () => {
    _function.scrollTo("guest-star");
  };

  const MobileBanner = () => {
    return (
      <>
        <Container justifyContent={"center"} display={"flex"}>
          <TitleImg
            marginTop={
              isExtraSmallScreen ? "40px" : isSmallScreen ? "60px" : "75px"
            }
            src={func.getStaticImg("illustration/title-d-soc.svg")}
            alt="title"
            maxWidth={"304px"}
          />
        </Container>

        <Container display="inline">
          <Container backgroundPosition={"0px -62px,0 19px,-20px -16px"}>
            <PialaByuImg
              margin={
                isExtraSmallScreen
                  ? "-70px auto -108px auto"
                  : isSmallScreen
                  ? "-50px auto -70px auto"
                  : "-50px auto -58px auto"
              }
              src={func.getStaticImg("illustration/conference/kv.png")}
              scale={
                isExtraSmallScreen
                  ? "scale(0.8)"
                  : isSmallScreen
                  ? "scale(0.95)"
                  : "scale(1)"
              }
              maxHeight={isMobileView ? "398px" : "425px"}
            />
            <img
              className="w-[257.315px] h-[83px] m-auto flex relative -top-[26px]"
              src={func.getStaticImg("illustration/soc-title.svg")}
              alt="kv-title"
            />
          </Container>

          <Container
            justifyContent={"center"}
            display={"flex"}
            className="relative -top-[16px]"
          >
            {data?.location && data?.city && (
              <Box>
                <Text
                  color="white"
                  size="small"
                  weight="bold"
                  removeGap
                  style={{ fontSize: "1.6rem" }}
                >
                  <ContainerHeadline>
                    {loc && (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <img
                          src={func.getStaticImg(
                            "/illustration/pin-location.svg"
                          )}
                        />
                        <Headline>{loc}</Headline>
                      </div>
                    )}

                    {city && eventDate && (
                      <Headline>{`${city}, ${eventDate}`}</Headline>
                    )}
                  </ContainerHeadline>
                </Text>
              </Box>
            )}
          </Container>
        </Container>

        {true ? (
          <Container justifyContent={"center"} display={"flex"}>
            <JadwalKlasemenContainer
              className={
                "!max-w-[none] !max-h-[none] !min-h-[unset] !mt-0 !mb-0"
              }
            >
              <Card
                bypassIsLive
                className={"!max-w-[40vw] !max-h-[58px]"}
                backgroundColor="white"
                text="Jadwal & Hasil Pertandingan"
                srcImg="/illustration/home-jadwal-v2.svg"
                onClick={() =>
                  navigate(buildURLWithParams(`/${slug}/jadwal-pertandingan`))
                }
              />

              <Card
                bypassIsLive
                className={"!max-w-[40vw] !max-h-[58px]"}
                backgroundColor="white"
                text="Klasemen & Statistik"
                srcImg="/illustration/home-klasemen-v2.svg"
                onClick={() =>
                  navigate(buildURLWithParams(`/${slug}/klasemen-pertandingan`))
                }
              />
            </JadwalKlasemenContainer>
          </Container>
        ) : (
          <ContentBottom>
            <Container justifyContent={"center"} display={"flex"}>
              <HintScroll onClick={handleScroll}>
                {"Scroll ke bawah"}
              </HintScroll>
            </Container>
            <Container justifyContent={"center"} display={"flex"}>
              <ScrollDownIcon
                onClick={handleScroll}
                alt="scroll-down"
                src={func.getStaticImg("icon/scroll-down.svg")}
              />
            </Container>
          </ContentBottom>
        )}
      </>
    );
  };

  const DesktopBanner = () => {
    return (
      <>
        <Row style={{ maxWidth: "1440px", alignSelf: "center" }}>
          <Col md={6}>
            <PialaByuImg
              margin={"auto"}
              src={func.getStaticImg("illustration/conference/kv-desktop.png")}
              maxHeight={"max-content"}
            />
            <img
              className="absolute -bottom-10 m-auto left-0 right-0"
              src={func.getStaticImg("illustration/soc-title.svg")}
              alt="kv-title"
            />
          </Col>
          <Col
            md={5}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div className="mt-[15vh]" style={{ justifyContent: "center" }}>
              <TitleImg
                marginTop={"0"}
                src={func.getStaticImg("illustration/title-d-soc.svg")}
                alt="title"
                position="inherit"
                height={"134.89px"}
              />

              <Container margin="64px 0 0 0">
                <>
                  {data?.location && (
                    <Container
                      justifyContent={"center"}
                      display={"flex"}
                      margin="0.5vh 0 0 0"
                    >
                      <Box className="w-[600px]">
                        <Text
                          color="white"
                          size="small"
                          weight="bold"
                          removeGap
                          style={{ fontSize: "1.6rem" }}
                        >
                          <ContainerHeadline>
                            {loc && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={func.getStaticImg(
                                    isMobileView
                                      ? "/illustration/pin-location.svg"
                                      : "/illustration/pin-location-d.svg"
                                  )}
                                />
                                <Headline className="uppercase">{loc}</Headline>
                              </div>
                            )}

                            {city && eventDate && (
                              <Headline>{`${city}, ${eventDate}`}</Headline>
                            )}
                          </ContainerHeadline>
                        </Text>
                      </Box>
                    </Container>
                  )}
                </>
                {true ? (
                  <Container justifyContent={"center"} display={"flex"}>
                    <JadwalKlasemenContainer>
                      <Card
                        bypassIsLive
                        className={"!max-w-[215px] !max-h-[75px]"}
                        backgroundColor="white"
                        text="Jadwal & Hasil Pertandingan"
                        srcImg="/illustration/home-jadwal-v2.svg"
                        onClick={() =>
                          navigate(
                            buildURLWithParams(`/${slug}/jadwal-pertandingan`)
                          )
                        }
                      />

                      <Card
                        bypassIsLive
                        className={"!max-w-[215px] !max-h-[75px]"}
                        backgroundColor="white"
                        text="Klasemen & Statistik"
                        srcImg="/illustration/home-klasemen-v2.svg"
                        onClick={() =>
                          navigate(
                            buildURLWithParams(`/${slug}/klasemen-pertandingan`)
                          )
                        }
                      />
                    </JadwalKlasemenContainer>
                  </Container>
                ) : (
                  <>
                    <Container
                      display={"flex"}
                      margin={isMobileView ? "3.6vh 0 0 0" : "15vh 0 0 0 "}
                    >
                      <HintScroll onClick={handleScroll}>
                        {"Scroll Kebawah"}
                      </HintScroll>
                    </Container>
                    <Container
                      justifyContent={"center"}
                      display={"flex"}
                      margin={"0px"}
                    >
                      <ScrollDownIcon
                        onClick={handleScroll}
                        alt="scroll-down"
                        src={func.getStaticImg("icon/scroll-down.svg")}
                      />
                    </Container>
                  </>
                )}
              </Container>
            </div>
          </Col>
        </Row>
      </>
    );
  };

  const Content = () => (isMobileView ? <MobileBanner /> : <DesktopBanner />);
  const backdropBanner = isMobileView
    ? func.getStaticImg("illustration/soc-banner-bg-m.png")
    : func.getStaticImg("illustration/soc-banner-bg.png");
  const backdropStyles = isMobileView
    ? {
        height: "100vh",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      }
    : {
        height: "96vh",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      };
  return (
    <>
      <BannerWrapper
        id="banner-landing"
        backgroundImage={backdropBanner}
        {...backdropStyles}
      >
        <Content />
      </BannerWrapper>
    </>
  );
};

export default BannerSoc;
